import React from 'react';
import { SystemRecommendation, sampleRecommendationData } from '@system-rec/decision-ui';

// Import CSS from local styles directory
import '../styles/SystemRecommendation.css';

function RecommendationPage() {
  const handlePDFGeneration = (mode: 'customer' | 'technical') => {
    console.log(`Generating PDF in ${mode} mode`);
    // PDF generation would be implemented here
  };

  return (
    <div className="page recommendation-page">
      <SystemRecommendation
        data={sampleRecommendationData}
        onGeneratePDF={handlePDFGeneration}
      />
    </div>
  );
}

export default RecommendationPage;
